module.exports = __webpack_public_path__ + "img/referral_active.acf847ba.svg";